import moment from "moment";
import React from "react";
import { Bar } from "react-chartjs-2";
import { useHistory } from "react-router-dom";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);
export const BarChart = ({ data }) => {
  const history = useHistory();
  const dates = data?.map((item) => item.date);
  const totalAmount = data.map((item) => item.totalAmount);
  const labels = data.map((item) => "");
  const chartData = {
    labels: labels,
    datasets: [
      {
        label: "Amount",
        data: totalAmount,
        backgroundColor: "rgba(0,110,255,1)",
        borderColor: "rgba(0,110,255,1)",
        borderWidth: 0.6,
        barPercentage: 0.8,
        categoryPercentage: 0.6,
      },
    ],
  };
  const handleLineClick = (event, chartElements) => {
    if (chartElements.length > 0) {
      const clickedIndex = chartElements[0].index;
      const clickedDate = data[clickedIndex].date;
      const date = moment(clickedDate);
      const startOfWeek = date.clone().startOf("isoWeek");
      const endOfWeek = date.clone().endOf("isoWeek");
      if (data[clickedIndex].isWageStatistics) {
        history.push({
          pathname: `${process.env.PUBLIC_URL}/wages`,
          state: {
            data: {
              startDate: startOfWeek.format("YYYY-MM-DD"),
              endDate: endOfWeek.format("YYYY-MM-DD"),
            },
            isWageListMove: true,
          },
        });
      } else if (data[clickedIndex].isInvoiceStatistics) {
        history.push({
          pathname: `${process.env.PUBLIC_URL}/invoices`,
          state: {
            data: {
              startDate: startOfWeek.format("YYYY-MM-DD"),
              endDate: endOfWeek.format("YYYY-MM-DD"),
            },
            isInvoiceListMove: true,
          },
        });
      }
    }
  };
  return (
    <Bar
      className="sales-bar-chart chartjs-render-monitor"
      width={180}
      // height={400}
      data={chartData}
      options={{
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            callbacks: {
              title: function (tooltipItem) {
                const clickedIndex = tooltipItem[0].dataIndex;
                const clickedDate = dates[clickedIndex];
                const currentDate = moment(clickedDate);
                const startOfWeek = currentDate.clone().startOf("isoWeek");
                const endOfWeek = currentDate.clone().endOf("isoWeek");
                return `${startOfWeek.format("MMM DD")} - ${endOfWeek.format("MMM DD")}`;
              },
              label: function (tooltipItem) {
                return `Amount: ${chartData.datasets[0].data[tooltipItem.dataIndex]}`;
              },
            },
            position: "nearest",
            backgroundColor: "#eff6ff",
            titleFont: {
              size: 11,
            },
            titleColor: "#000000",
            titleMarginBottom: 4,
            bodyColor: "#000000",
            bodyFont: {
              size: 10,
            },
            bodySpacing: 3,
            yPadding: 8,
            xPadding: 8,
            footerMarginTop: 0,
            displayColors: false,
          },
        },
        layout: {
          padding: {
            bottom: 0,
          },
        },
        scales: {
          y: {
            display: false,
            ticks: {
              beginAtZero: true,
              min: 0,
            },
          },
          x: {
            display: true,
            grid: {
              display: false,
            },
          },
        },
        maintainAspectRatio: false,
        onClick: handleLineClick,
      }}
    />
  );
};
